import React, { useEffect, useRef } from 'react';

import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import Spinner from 'react-bootstrap/Spinner';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons';

import './style.scss';

const SearchBox = ({
  id,
  placeholder,
  onChange,
  onReset,
  defaultValue = "",
  disabled= false,
  isLoading = false,
}) => {
  const inputRef = useRef();
  const handleInputChange = (event) => {
    event.preventDefault();
    onChange(event.target.value);
  };
  const handleInputReset = () => {
    onReset();
    document.forms[id].reset();
  }
  const preventDefaultSubmit = (event) => event.preventDefault();

  useEffect(() => {
    if (!isLoading && !!inputRef.current?.value) {
      inputRef.current.focus();
    }
  }, [isLoading])

  return (
    <Form name={id} onSubmit={preventDefaultSubmit}>
      <InputGroup>
        <Form.Control
          ref={inputRef}
          placeholder={placeholder}
          name={`${id}-input`}
          id={`${id}-input`}
          onChange={handleInputChange}
          disabled={isLoading || disabled}
          defaultValue={defaultValue}
        />
        <InputGroup.Text>
          {isLoading ? (
            <Spinner animation="border" variant="secondary">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          ) : (
            <Button
              className="p-0 d-flex justify-content-center border-4"
              variant="outline"
              onClick={handleInputReset}
              disabled={disabled}
            >
              <FontAwesomeIcon icon={faTimesCircle} className="fa-close search-term-clear" />
            </Button>
          )}
        </InputGroup.Text>
      </InputGroup>
    </Form>
  );
}

export default SearchBox;
